import { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { Loading } from '@components';

const SignIn = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const url = window.location.href;
    const inviteMatches = url.match(/invitation=([^&]+)/);
    const orgMatches = url.match(/login=([^&]+)/);

    loginWithRedirect({
      organization: orgMatches && inviteMatches ? orgMatches[1] : undefined,
      invitation: orgMatches && inviteMatches ? inviteMatches[1] : undefined,
    });
  }, [loginWithRedirect]);

  return <Loading />;
};

export { SignIn };
